import {
  activeTabQuery,
  isEditViewQuery,
  isFirstFlowQuery,
  isProcessingFacility,
  scopeTab,
} from 'constants/constants';
import { removeFalsyKeys } from 'shared/utils/removeFalsyKeys';

export function parseIsEditViewParam(raw: unknown): boolean {
  if (raw === true || raw === 1) return true;
  if (typeof raw === 'string') {
    const lower = raw.toLowerCase();
    return lower === 'true' || lower === '1';
  }
  return false;
}

/** Derived UI flags for Scope 3 header (`isEditView` from URL; `undefined` = legacy always-edit pages). */
export function resolveScopeThreeHeaderLayoutMode(isEditView?: boolean) {
  const legacyMode = isEditView === undefined;
  const inEditMode = legacyMode || isEditView === true;
  const inViewMode = !legacyMode && isEditView === false;
  return { legacyMode, inEditMode, inViewMode };
}

type AdeParamBag = Record<string, unknown>;

/**
 * Builds ADE URL search params preserving year / first-flow / PF / scope tab.
 * Omit `withEditView` or pass false to leave edit mode out of the query (matches Scope 1).
 */
export function buildAdeSearchState(
  params: AdeParamBag,
  options?: { withEditView?: boolean }
): Record<string, unknown> {
  const next: Record<string, unknown> = {};
  const at = params[activeTabQuery];
  if (at !== undefined && at !== null && at !== '')
    next[activeTabQuery] = at;
  if (params[isFirstFlowQuery]) next[isFirstFlowQuery] = true;
  const pf = params[isProcessingFacility];
  if (
    pf !== undefined &&
    pf !== null &&
    pf !== ''
  ) {
    next[isProcessingFacility] = pf;
  }
  const st = params[scopeTab];
  if (st !== undefined && st !== null && st !== '')
    next[scopeTab] = st;
  if (options?.withEditView) next[isEditViewQuery] = true;
  return removeFalsyKeys(next);
}
